import React, { useEffect, useState, useRef } from "react";
import { Accordion, Form } from "react-bootstrap";
import { btnTranslate, employeeExperienceTranslate, wheelCollaboratorTranslate } from "../../../../i18n/translatedMessages";

const ProfessionalExperienceAccordion = ({
	experiences,
	industryList,
	areaList,
	hierarchicalLevelList,
	handleChange,
	handleSend,
	isChecked,
	setIsChecked,
	handleCheckboxChange,
}) => {
	const selectRef = useRef(null);

	const [activeState, setActiveState] = useState(null);

	useEffect(() => {
		const updateIsChecked = (experiences) => {
			const newIsChecked = experiences.map((el) => (el.departure_date === "Actual" ? true : false));
			setIsChecked(newIsChecked);
		};

		updateIsChecked(experiences);
	}, [experiences]);

	return (
		<>
			<Accordion activeKey={activeState} flush>
				{experiences.map((el, i) => {
					return (
						<div key={i}>
							<Accordion.Item className="shadow my-3 rounded-2 border border-1" eventKey={i.toString()}>
								<Accordion.Header onClick={() => setActiveState(activeState === i.toString() ? null : i.toString())}>
									#{i + 1} - {experiences[i]?.company || ""}
								</Accordion.Header>
								<Accordion.Body>
									<div className="col pb-4 pt-1">
										<span
											style={{
												fontSize: 14,
												color: "#3b3b5c",
											}}
										>
											Los campos con * son obligatorios.
										</span>
									</div>
									<div className="row d-flex justify-content-center">
										<div className="col-4">
											<Form.Group className="mb-3">
												<Form.Label>{employeeExperienceTranslate.historicProfessionalEENameCompany} *</Form.Label>
												<Form.Control
													className="mt-0"
													type="text"
													value={el?.company || ""}
													name="company"
													data-index={i}
													onChange={(e) => handleChange(e)}
												/>
											</Form.Group>
										</div>
										<div className="col-4">
											<Form.Group className="mb-3">
												<Form.Label>{employeeExperienceTranslate.historicProfessionalEEAreaCompany} *</Form.Label>
												<Form.Select
													className="border-primary-inputs"
													name="industry_id"
													data-index={i}
													value={Number(el.industry_id) || 0}
													onChange={(e) => handleChange(e)}
													ref={selectRef}
												>
													<option value={0} data-index={0}>
														Seleccione
													</option>
													{industryList?.map((industry) => (
														<option value={industry?.id} data-text={industry?.name} key={industry?.id}>
															{industry.name}
														</option>
													))}
												</Form.Select>
											</Form.Group>
										</div>
										<div className="col-4">
											<Form.Group className="mb-3">
												<Form.Label>{employeeExperienceTranslate.historicProfessionalEEJob} *</Form.Label>
												<Form.Control
													className="mt-0"
													type="text"
													value={el?.jobname || ""}
													name="jobname"
													data-index={i}
													onChange={(e) => handleChange(e)}
												/>
											</Form.Group>
										</div>
									</div>
									<div className="row">
										<div className="col-3">
											<Form.Group className="mb-3">
												<Form.Label>{employeeExperienceTranslate.historicProfessionalEEHierarchicalLevel} *</Form.Label>
												<Form.Select
													className="border-primary-inputs"
													name="hierarchical_level_id"
													data-index={i}
													value={Number(el.hierarchical_level_id) || 0}
													onChange={(e) => handleChange(e)}
													ref={selectRef}
												>
													<option value={0} data-index={0}>
														Seleccione
													</option>
													{hierarchicalLevelList?.map((hierarchicalLevel) => (
														<option value={hierarchicalLevel?.id} data-text={hierarchicalLevel?.level} key={hierarchicalLevel?.id}>
															{hierarchicalLevel.level}
														</option>
													))}
												</Form.Select>
											</Form.Group>
										</div>
										<div className="col-3">
											<Form.Group className="mb-3">
												<Form.Label>{employeeExperienceTranslate.historicProfessionalEEArea} *</Form.Label>
												<Form.Select
													className="border-primary-inputs"
													name="area_id"
													data-index={i}
													value={Number(el.area_id) || 0}
													onChange={(e) => handleChange(e)}
													ref={selectRef}
												>
													<option value={0} data-index={0}>
														Seleccione
													</option>
													{areaList?.map((area) => (
														<option value={area?.id} data-text={area?.profileArea} key={area?.id}>
															{area.profileArea}
														</option>
													))}
												</Form.Select>
											</Form.Group>
										</div>
										<div className="col-2 d-flex align-content-center">
											<Form.Group className="mb-3 d-flex flex-column">
												<Form.Label>{employeeExperienceTranslate.formationEECurrentlyWorking}</Form.Label>
												<Form.Check
													id={`isStudying${i}`}
													className="mt-2"
													type="checkbox"
													label={employeeExperienceTranslate.formationEEYes}
													checked={isChecked[i] ? isChecked[i] : false}
													onChange={() => handleCheckboxChange(i)}
												/>
											</Form.Group>
										</div>
										<div className="col-2">
											<Form.Group className="mb-3">
												<Form.Label>{employeeExperienceTranslate.formationEEEntryDateCourse} *</Form.Label>
												<Form.Control
													className="border-primary-inputs"
													type="date"
													name="entry_date"
													data-index={i}
													value={el.entry_date?.split("-").join("-") || "2000-01-01"}
													onChange={(e) => handleChange(e)}
												/>
											</Form.Group>
										</div>
										<div className="col-2">
											{isChecked[i] ? (
												""
											) : (
												<Form.Group className="mb-3">
													<Form.Label>{employeeExperienceTranslate.formationEELeaveDateCourse} *</Form.Label>
													<Form.Control
														className="border-primary-inputs"
														type="date"
														name="departure_date"
														data-index={i}
														value={el.departure_date?.split("-").join("-") || "2014-01-01"}
														onChange={(e) => handleChange(e)}
													/>
												</Form.Group>
											)}
										</div>
									</div>
									<div className="row d-flex justify-content-center">
										<div className="col-6">
											<Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">
												<Form.Label>{wheelCollaboratorTranslate.functionsTitle} </Form.Label>
												<Form.Control
													className="border-primary-inputs"
													as="textarea"
													rows={5}
													value={experiences[i]?.description || ""}
													name="description"
													data-index={i}
													onChange={(e) => handleChange(e)}
												/>
											</Form.Group>
										</div>
										<div className="col-6">
											<Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">
												<Form.Label>{wheelCollaboratorTranslate.achievementsTitle}</Form.Label>
												<Form.Control
													className="border-primary-inputs"
													as="textarea"
													rows={5}
													value={experiences[i]?.achievements || ""}
													name="achievements"
													data-index={i}
													onChange={(e) => handleChange(e)}
												/>
											</Form.Group>
										</div>
									</div>
									<div className="row mb-2 d-flex justify-content-end">
										<div style={{ maxWidth: "150px" }}>
											<button className="btn rounded-pill addEmployeeInfo-btn" onClick={() => handleSend(i)}>
												{btnTranslate.saveButton}
											</button>
										</div>
									</div>
								</Accordion.Body>
							</Accordion.Item>
						</div>
					);
				})}
			</Accordion>
		</>
	);
};

export default ProfessionalExperienceAccordion;
